var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "hide-focus",
      attrs: {
        id: "page-focus-target"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pb-6 pt-0"
                },
                [_vm._v(" Migration Request ")]
              ),
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-header",
                    [
                      _vm.step_counter === 1
                        ? [_vm._v(" Let’s begin your migration! ")]
                        : [_vm._v(" Provide your Migration Details ")]
                    ],
                    2
                  ),
                  _c(
                    "gg-card-text",
                    [
                      _c(
                        "v-row",
                        {
                          attrs: {
                            justify: "center",
                            "no-gutters": ""
                          }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                md: "11"
                              }
                            },
                            [
                              _c(
                                "v-stepper",
                                {
                                  model: {
                                    value: _vm.step_counter,
                                    callback: function callback($$v) {
                                      _vm.step_counter = $$v
                                    },
                                    expression: "step_counter"
                                  }
                                },
                                [
                                  _c(
                                    "v-stepper-header",
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.step_counter > 1,
                                            step: "1"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Migration Request: Introduction "
                                          )
                                        ]
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            complete: _vm.step_counter > 2,
                                            step: "2"
                                          }
                                        },
                                        [_vm._v(" Migration Request: Details ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-stepper-items",
                                    [
                                      _c(
                                        "v-stepper-content",
                                        {
                                          attrs: {
                                            step: "1"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "app-card card-borderless"
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-form",
                                                    {
                                                      attrs: {
                                                        "data-vv-scope": "step1"
                                                      },
                                                      on: {
                                                        submit: function submit(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass: "body-1"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.step_one.title
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c("gg-select", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: "required",
                                                            expression:
                                                              "'required'"
                                                          }
                                                        ],
                                                        attrs: {
                                                          label:
                                                            "Select a service",
                                                          "aria-label":
                                                            "Select a service",
                                                          outlined: "",
                                                          items:
                                                            _vm.servicesList,
                                                          name: "Service",
                                                          "item-text": "domain",
                                                          "item-value": "id",
                                                          "error-messages": _vm.errors.collect(
                                                            "step1.Service"
                                                          )
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "item",
                                                            fn: function fn(
                                                              _ref
                                                            ) {
                                                              var item =
                                                                _ref.item
                                                              return [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      item.name
                                                                    ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      item.domain
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm.step_one.model
                                                              .hosting_id,
                                                          callback: function callback(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.step_one
                                                                .model,
                                                              "hosting_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "step_one.model.hosting_id"
                                                        }
                                                      }),
                                                      _c(
                                                        "gg-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            tile: ""
                                                          },
                                                          on: {
                                                            click: function click(
                                                              $event
                                                            ) {
                                                              return _vm.moveToStep(
                                                                2,
                                                                "step1"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v(" Continue ")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-stepper-content",
                                        {
                                          attrs: {
                                            step: "2"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "app-card card-borderless"
                                            },
                                            [
                                              _c(
                                                "gg-card-title",
                                                {
                                                  staticClass: "pb-6",
                                                  attrs: {
                                                    subtitle: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " Migration Instructions & Details "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "mb-6"
                                                },
                                                [
                                                  _vm._v(
                                                    " Now we need some information about your previous provider. Answer as accurately as possible to expedite your request."
                                                  ),
                                                  _c("br"),
                                                  _c("br"),
                                                  _vm._v(
                                                    " Don't know everything? No problem! Just tell us what you can, and we will be in touch if we have any questions."
                                                  ),
                                                  _c("br"),
                                                  _c("br"),
                                                  _vm._v(
                                                    " In most cases it is ideal to provide us with your primary control panel or account management login. This will usually give us everything we need to complete your migration. You can provide us with your FTP information instead if you are just transferring a website. Use the Additional Instructions field to supply additional login information and/or other instructions for us."
                                                  ),
                                                  _c("br"),
                                                  _c("br"),
                                                  _vm._v(
                                                    " More information about migrating to GreenGeeks is available in our "
                                                  ),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "https://www.greengeeks.com/kb/2498/greengeeks-migration-policy/",
                                                        target: "_blank"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Migration Policy "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(". ")
                                                ]
                                              ),
                                              _c(
                                                "v-form",
                                                {
                                                  on: {
                                                    submit: function submit(
                                                      $event
                                                    ) {
                                                      $event.preventDefault()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .provider,
                                                                expression:
                                                                  "rules.provider"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "Previous Hosting Provider",
                                                              "aria-label":
                                                                "Previous Hosting Provider",
                                                              "data-vv-name":
                                                                "provider",
                                                              "data-vv-as":
                                                                "Previous Hosting Provider",
                                                              "error-messages": _vm.errors.collect(
                                                                "provider"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .previous_provider,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "previous_provider",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.previous_provider"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .cp_url,
                                                                expression:
                                                                  "rules.cp_url"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "Control Panel URL",
                                                              "aria-label":
                                                                "Control Panel URL",
                                                              "data-vv-name":
                                                                "cp_url",
                                                              "data-vv-as":
                                                                "Control Panel URL",
                                                              "error-messages": _vm.errors.collect(
                                                                "cp_url"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model.cp_url,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "cp_url",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.cp_url"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-select", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .cp_type,
                                                                expression:
                                                                  "rules.cp_type"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "Control Panel Type",
                                                              "aria-label":
                                                                "Control Panel Type",
                                                              "data-vv-name":
                                                                "cp_type",
                                                              "data-vv-as":
                                                                "Control Panel Type",
                                                              "error-messages": _vm.errors.collect(
                                                                "cp_type"
                                                              ),
                                                              items:
                                                                _vm.step_two
                                                                  .cp_items,
                                                              "item-text":
                                                                "name",
                                                              "item-value":
                                                                "value"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .cp_type,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "cp_type",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.cp_type"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .hostname,
                                                                expression:
                                                                  "rules.hostname"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "FTP Hostname",
                                                              "aria-label":
                                                                "FTP Hostname",
                                                              "data-vv-name":
                                                                "hostname",
                                                              "data-vv-as":
                                                                "FTP Hostname",
                                                              "error-messages": _vm.errors.collect(
                                                                "hostname"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .hostname,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "hostname",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.hostname"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .username,
                                                                expression:
                                                                  "rules.username"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "Control Panel/FTP Username",
                                                              "aria-label":
                                                                "Control Panel/FTP Username",
                                                              "data-vv-name":
                                                                "username",
                                                              "data-vv-as":
                                                                "Control Panel/FTP Username",
                                                              "error-messages": _vm.errors.collect(
                                                                "username"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .username,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "username",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.username"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12",
                                                            sm: "6",
                                                            md: "4"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm.rules
                                                                    .password,
                                                                expression:
                                                                  "rules.password"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              label:
                                                                "Control Panel/FTP Password",
                                                              "aria-label":
                                                                "Control Panel/FTP Password",
                                                              "data-vv-name":
                                                                "password",
                                                              "data-vv-as":
                                                                "Control Panel/FTP Password",
                                                              "error-messages": _vm.errors.collect(
                                                                "password"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .password,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "password",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.password"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12"
                                                          }
                                                        },
                                                        [
                                                          _c("gg-input-label", [
                                                            _vm._v("Comments")
                                                          ]),
                                                          _c("v-textarea", {
                                                            staticClass:
                                                              "gg-input",
                                                            attrs: {
                                                              placeholder:
                                                                "Additional Instructions or Comments (for example: additional " +
                                                                "login information, steps to login, etc)",
                                                              outlined: ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model.notes,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "notes",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.notes"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-0",
                                                          attrs: {
                                                            cols: "12"
                                                          }
                                                        },
                                                        [
                                                          _c("v-checkbox", {
                                                            attrs: {
                                                              "true-value": 1,
                                                              "false-value": 0,
                                                              color: "primary"
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function fn() {
                                                                    return [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "v-label",
                                                                          staticStyle: {
                                                                            cursor:
                                                                              "pointer"
                                                                          },
                                                                          attrs: {
                                                                            "aria-hidden":
                                                                              "true"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " I use a third party email service and I would like to keep them as our mail host. "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  },
                                                                  proxy: true
                                                                }
                                                              ]
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.step_two
                                                                  .model
                                                                  .thirdpartymail,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.step_two
                                                                    .model,
                                                                  "thirdpartymail",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "step_two.model.thirdpartymail"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-0",
                                                          attrs: {
                                                            cols: "12"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "gg-btn",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                tile: "",
                                                                loading:
                                                                  _vm.loading
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.submitForm
                                                              }
                                                            },
                                                            [_vm._v(" Submit ")]
                                                          ),
                                                          _c(
                                                            "gg-btn",
                                                            {
                                                              attrs: {
                                                                tile: "",
                                                                text: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function click(
                                                                  $event
                                                                ) {
                                                                  _vm.step_counter = 1
                                                                }
                                                              }
                                                            },
                                                            [_vm._v(" Back ")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }